import React from 'react';

const EnquirySearch: React.FC = () => {
  return (
    <h1>This page is under construction</h1>
  );
};

export default EnquirySearch;
